import type * as OnrampMailingListCTA from '../types/OnrampMailingListCTA'
import formModuleComponentParser from './FormModule'

export default function onrampMailingListCTAComponentParser(
  rawComponent: OnrampMailingListCTA.Raw,
): OnrampMailingListCTA.Parsed {
  const { notifyCta, ...props } = rawComponent.onrampMailingListCta
  const parsedFormModule = formModuleComponentParser({
    acfFcLayout: 'form_module',
    ...notifyCta,
  })

  return {
    name: 'OnrampMailingListCTA',
    props: {
      formModule: parsedFormModule.props,
      ...props,
    },
  }
}
